import { defineComponent as _defineComponent } from 'vue'
import InputPassword from "@/components/ui/input/InputPassword.vue";
  import PasswordProgress from "@/components/ui/PasswordProgress.vue";
  import { computed, reactive, ref } from "vue";
  import { helpers, required, sameAs } from "@vuelidate/validators";
  import useVuelidate from "@vuelidate/core";
  import { validatePassword } from "@/helpers/validation";
  import { useStore } from "vuex";
  import router from "@/router";
  import {
    confirmPasswordError,
    newPasswordError,
  } from "@/constants/validation";
  import { POSITION, useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileChangePassword',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const toast = useToast();
  const form = reactive({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const rules = computed(() => {
    return {
      currentPassword: { required, $autoDirty: true },
      newPassword: {
        required,
        validatePassword: helpers.withMessage(
          newPasswordError,
          validatePassword
        ),
      },
      confirmPassword: {
        required,
        sameAsPassword: helpers.withMessage(
          confirmPasswordError,
          sameAs(form.newPassword)
        ),
        $autoDirty: true,
      },
    };
  });
  const v$ = useVuelidate(rules, form);
  const currentPassError = ref("");

  const changePassword = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    store
      .dispatch("user/changePasswordForLoginUser", {
        oldPassword: form.currentPassword,
        newPassword: form.newPassword,
      })
      .then(() => {
        router.push({ name: "ProfileGeneralV2" });
        toast.success("The password was updated successfully.", {
          position: POSITION.TOP_CENTER,
        });
      })
      .catch((err) => {
        currentPassError.value = err.response.data.message;
      });
  };

const __returned__ = { store, toast, form, rules, v$, currentPassError, changePassword, InputPassword, PasswordProgress, computed, reactive, ref, get helpers() { return helpers }, get required() { return required }, get sameAs() { return sameAs }, get useVuelidate() { return useVuelidate }, get validatePassword() { return validatePassword }, get useStore() { return useStore }, get router() { return router }, get confirmPasswordError() { return confirmPasswordError }, get newPasswordError() { return newPasswordError }, get POSITION() { return POSITION }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})